window.EstimatePayment = new(function () {

    var that = this;
    //var coinSymbol = '$';
    percent = 0;

    /**
     * Listener Estimate payments
     */
    this.init = function () {
        percent = (typeof $('#branch-financing').val() != 'undefined') ? $('#branch-financing').val() : percent;
        $('#estimate-car-model').on('change', that.getTrimsEstimatePayment);
        $('#trim').on('change', that.changeTrimPrice);
        $('#terms-months').on('change', that.changeTermsMonthly);

        $('#down-payment').keyup(delay(function (e) {
            that.addDownPayment($(this).val());
        }, 500));

        $('#branch-financing').on('change', that.changePercent);
    };

    /**
     * Get the percent for the dealer financing
     */
    this.changePercent = function () {
        var currentValue = $(this).val();
        if (currentValue && !isNaN(currentValue)) {
            percent = parseFloat(currentValue);
        }

        // recalcula downpayment
        downPayment = getDownPaymentFromBranchOrDefault();
        $('#down-payment').val(downPayment.toFixed(2)).trigger('keyup');

        // recargar plazos del branch seleccionado
        var branchId = $('#branch-financing option:selected').data('branch');
        that.reloadTermsByBranch(branchId);

        that.updateElements();
    };

    this.reloadTermsByBranch = function (branchId) {
        if (!branchId) return;

        $.ajax({
            type: 'POST',
            url: getMonthsByBranchRoute,
            data: {
                '_token': $(document).find('meta[name="csrf-token"]').attr("content"),
                'branch_id': branchId
            },
            success: function (months) {
                var options = '';
                $.each(months, function (_, m) {
                    // m.months = 18, m.month_name = "18 MESES", m.percentage = rate
                    options += `<option value="${m.months}" data-rate="${m.percentage}">${m.month_name}</option>`;
                });

                $('#terms-months').empty().append(options).trigger('change');
            }
        });
    };
    /**
     * get trims for model Estimate payments
     */
    this.getTrimsEstimatePayment = function () {
        var selectedModel = $(this).children('option:selected').val();

        //ajax get trims
        $.ajax({
            type: 'POST',
            url: getTrimsRoute,
            data: {
                '_token': $(document).find('meta[name="csrf-token"]').attr("content"),
                'car_id': selectedModel,
            },
            success: function (response) {

                var selectOptions = '';

                $.each(response, function (index, value) {
                    if(index == 0) {
                        trimPrice = value.price;
                    }

                    var priceToShow = '';
                    var coinSymbolToShow = (value.price_text !== null) ? value.price_text : value.coin_symbol;

                    if(coinSymbolToShow == null) {
                        coinSymbolToShow = '';
                    }
                    if(parseFloat(value.price) > 0) {
                        priceToShow = value.price;
                    }

                    selectOptions += '<option data-price="'+ value.price +'" data-pricetext="'+ value.price_text +'" value="'+ value.name +'">';
                    selectOptions += value.name;
                    selectOptions += (priceToShow != '') ? ' - ' + coinSymbolToShow + ' ' + BuildCars.formatNumber(priceToShow) : '';
                    selectOptions += '</option>';

                    coinSymbol = coinSymbolToShow;
                });

                $('#trim option').remove();
                $('#trim').append(selectOptions);
                $('#trim').trigger('change');

                that.updateElements();

            }
        });

    };

    /**
     * Change trim value when
     * user select a different
     */
    this.changeTrimPrice = function () {
        var newTrimPrice = $(this).find('option:selected').data('price');
        var newTrimPriceAWD = $(this).find('option:selected').data('price-awd');
        selectedCar['price_text'] = $(this).find('option:selected').data('pricetext');

        if(selectedCar['powertrain'] == 'AWD') {
            newTrimPrice = newTrimPriceAWD;
        }
        trimPrice = parseFloat(newTrimPrice);

        //20% downpayment
        downPayment = getDownPaymentFromBranchOrDefault();
        $('#down-payment').val(downPayment.toFixed(2));
        $('#down-payment').trigger('keyup');

        //$('#down-payment').attr('value', downPayment);
        $('#down-payment').val(downPayment.toFixed(2));
        $('#down-payment').trigger('keyup');

        //check for available powertrain
        BuildCars.getPowertrain();

        that.updateElements();
    };

    /**
     * Change terms monthly when
     * user select a different
     */
    this.changeTermsMonthly = function () {

        if(currentCountry == 'costa-rica') {
            //For Costa Rica
            that.costaRica();
        }

        that.updateElements();
    };

    /**
     * Add down payment
     * if user added
     *
     * @param quantity
     */
    this.addDownPayment = function (quantity) {
        quantity = (quantity == '') ? 0 : BuildCars.notFormatNumber(quantity);
        downPayment = parseFloat(quantity);

        //var formatedDownPayment = BuildCars.formatNumber(downPayment.toFixed(2));
        //$('#down-payment').val(formatedDownPayment);

        if(currentCountry == 'costa-rica') {
            //For Costa Rica
            that.costaRica();
        }

        that.updateElements();
    };

    /**
     * Update Elements with prices
     */
    this.updateElements = function () {
        // meses (numérico, ya lo tienes en value)
        var termMonths = parseInt($('#terms-months').val(), 10) || 0;

        // rate del plazo (viene del option seleccionado)
        var termRate = parseFloat($('#terms-months option:selected').data('rate'));

        // fallback por si no viene
        if (!isFinite(termRate)) {
            termRate = parseFloat(percent) || 0; // usa el percent del branch como respaldo
        }

        if (!termMonths || termMonths <= 0) termMonths = 12;
        if (!isFinite(trimPrice)) trimPrice = 0;
        if (!isFinite(downPayment)) downPayment = 0;

        // OJO: tu lógica actual es “interés simple total” (no APR real)
        // totalInterest = (termRate% * trimPrice)
        var rateAmount = (termRate * trimPrice) / 100;

        var financed = trimPrice - parseFloat(downPayment);
        var totalPriceMonthly = (financed + rateAmount) / termMonths;

        if (!isFinite(totalPriceMonthly) || totalPriceMonthly < 0) totalPriceMonthly = 0;

        var priceText = (selectedCar['price_text'] && !$.isNumeric(selectedCar['price_text']))
            ? selectedCar['price_text'].toUpperCase()
            : coinSymbol;

        $('.EstimateAmount').html(priceText + BuildCars.formatNumber(totalPriceMonthly.toFixed(2)));
        BuildCars.pushNewSummaryData();
    };

    /**
     * Delay for keyup
     * @param callback
     * @param ms
     * @returns {function(...[*]=)}
     */
    function delay(callback, ms) {
        var timer = 0;
        return function() {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }

    function getDownPaymentFromBranchOrDefault() {
        // Lee el data-downpayment del option seleccionado
        var dpAttr = $('#branch-financing option:selected').data('downpayment');

        // Si existe y es numérico y > 0, úsalo como porcentaje
        if (dpAttr !== undefined && dpAttr !== null && dpAttr !== '' && !isNaN(dpAttr) && parseFloat(dpAttr) > 0) {
            return (parseFloat(dpAttr) / 100) * trimPrice;
        }

        // Default 20%
        return (20 / 100) * trimPrice;
    }

    /**
     *  Start Costa Rica
     *  ==============================================================================================================
     */


    /**
     * Listener
     */
    this.costaRica = function () {
        var monthsCR = $('#terms-months').val();
        var branchIdCR = $('#branch-financing').children("option:selected").data('branch');

        that.searchAdjustmentCostaRica(monthsCR, branchIdCR);
    };

    /**
     * Search Bank Adjustment
     * @param monthsCR
     * @param branchIdCR
     */
    this.searchAdjustmentCostaRica = function (monthsCR, branchIdCR) {
        $('.wait-for-change').addClass('active');
        $.ajax({
            type: 'POST',
            url: searchAjustmentRoute,
            data: {
                '_token': $(document).find('meta[name="csrf-token"]').attr("content"),
                'branch_id': branchIdCR,
                'months': monthsCR,
            },
            success: function (response) {

                that.doAdjustmentCostaRica( response[1] );

            }
        });
    };

    /**
     * Apply the adjustment
     * @param quantity
     */
    this.doAdjustmentCostaRica = function (quantity) {
        var downPayment = $('#down-payment').val();
        var montoFinanciar = trimPrice - downPayment;
        totalPriceMonthly = (montoFinanciar / 10000) * quantity;

        //Monthly Payment
        $('.EstimateAmount').html(coinSymbol + BuildCars.formatNumber(totalPriceMonthly.toFixed(2)));
        $('.wait-for-change').removeClass('active');

        BuildCars.pushNewSummaryData();
    };

    /**
     *  End Costa Rica
     *  ==============================================================================================================
     */

    /**
     *  Start Guatemala
     *  ==============================================================================================================
     */


    /**
     * Listener
     */
    this.guatemala = function (newTrimPrice, rate) {

        var priceAdjustment = that.doAdjustmentGuatemala();

        newTrimPrice = newTrimPrice + priceAdjustment;
        var interest = percent / 100;
        var interestRate = interest / 12;
        rate = interestRate * newTrimPrice;
        var interestRateFixed = parseFloat(interestRate.toFixed(8));
        var pow = 1-(1 + interestRateFixed) ** (termMonths * -1);
        var rateFixed = parseFloat(rate.toFixed(4));
        var powFixed = parseFloat(pow.toFixed(8));

        var monthlyPayment = rateFixed / powFixed;
        return monthlyPayment;
    };

    this.doAdjustmentGuatemala = function() {

        var montoFinanciar = trimPrice - downPayment;
        var percentEscrituracion = (2.3 / 100) * montoFinanciar;

        return percentEscrituracion;
    };


    /**
     *  End Guatemala
     *  ==============================================================================================================
     */

})();
